module.exports = __webpack_public_path__ + "media/images/sozai_sex_2-18c0e99e.png";